import {
  toCompilableQuery,
  wrapPowerSyncWithDrizzle,
} from '@powersync/drizzle-driver';
import { PowerSyncDatabase } from '@powersync/web';

import { AppSchema, schema } from './schema';

export const powerSync = new PowerSyncDatabase({
  schema: AppSchema,
  database: {
    dbFilename: 'docnboard.db',
  },
});

export { toCompilableQuery };

export const db = wrapPowerSyncWithDrizzle(powerSync, {
  schema,
});
